import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { LanguageProvider } from './context/LanguageContext'
import { SubscriptionProvider } from './context/SubscriptionContext'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import AddWarranty from './pages/AddWarranty'
import WarrantyDetail from './pages/WarrantyDetail'
import Profile from './pages/Profile'
import Pricing from './pages/Pricing'
import PaymentResult from './pages/PaymentResult'
import LandingPage from './pages/LandingPage'
import './App.css'

function ProtectedRoute({ children }) {
  const { session, loading } = useAuth()
  if (loading) return (
    <div className="splash">
      <img src="/damanati_logo_transparent.png" alt="ضمانتي"
        style={{ height: '80px', objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
    </div>
  )
  return session ? children : <Navigate to="/login" replace />
}

function GuestRoute({ children }) {
  const { session, loading } = useAuth()
  if (loading) return null
  return !session ? children : <Navigate to="/dashboard" replace />
}

function AppRoutes() {
  const { session } = useAuth()
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode')
    return saved !== null ? saved === 'true' : true
  })

  useEffect(() => {
    document.body.classList.toggle('light-mode', !darkMode)
    localStorage.setItem('darkMode', darkMode)
  }, [darkMode])

  return (
    <Routes>
      <Route path="/login"       element={<GuestRoute><Login /></GuestRoute>} />
      <Route path="/register"    element={<GuestRoute><Register /></GuestRoute>} />
      <Route path="/dashboard"   element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/add"         element={<ProtectedRoute><AddWarranty /></ProtectedRoute>} />
      <Route path="/warranty/:id" element={<ProtectedRoute><WarrantyDetail /></ProtectedRoute>} />
      <Route path="/warranty/:id/edit" element={<ProtectedRoute><AddWarranty /></ProtectedRoute>} />
      <Route path="/profile"     element={<ProtectedRoute><Profile darkMode={darkMode} setDarkMode={setDarkMode} /></ProtectedRoute>} />
      <Route path="/pricing"     element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/payment-result" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
      <Route path="/"             element={session ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
      <Route path="*"            element={<Navigate to={session ? '/dashboard' : '/'} replace />} />
    </Routes>
  )
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <SubscriptionProvider>
            <AppRoutes />
          </SubscriptionProvider>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  )
}

export default App
